export default __webpack_public_path__ + "static/media/cardNoiseDark.ea3aef96.png";